import IconCalendar from 'assets/icons/calendar-2.svg';
import IconTruck from 'assets/icons/delivery-truck-2.svg';
import cn from 'classnames';
import { useConfig } from 'config';
import { ShopId } from 'constants/shop';
import useExperiment from 'hooks/common/use-experiment';
import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import { PRE_ORDER_SHIPPING_DATE } from 'modules/product-details/components/buy-panel/constants';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ShippingElementProps {
  className?: string;
  isPreorderProduct: boolean;
  isVariantAvailable?: boolean;
}

/**
 * Component that displays the shipping information of the product.
 */
const ShippingElement: React.FC<ShippingElementProps> = ({
  className,
  isPreorderProduct,
  isVariantAvailable,
}) => {
  const { shopId } = useConfig();
  const { isEc } = useIsExistingCustomer();

  /** Estimated shipping time  */
  const shippingTime = shopId === ShopId.DE ? '1-3' : '1-2';

  // FE: AB Test displaying actual saved shipping cost vs. just "kostenlose lieferung"
  // @see https://petsdeli.atlassian.net/browse/PT-6265
  const { variant, loading } = useExperiment({
    baseEntryId: '79HXObA8VgoGh3P9vktjMk',
  });

  const messageNewCustomer =
    variant === 1
      ? 'pdp:buy-panel:free-shipping-new-customer:test'
      : 'pdp:buy-panel:free-shipping-new-customer:without-style';

  if (loading) return null;

  return (
    <div
      className={cn(
        'w-full items-center text-sm text-text-secondary',
        className
      )}
    >
      <div className="mb-2 flex items-center">
        <IconTruck className="mr-1.5 h-5 w-5 shrink-0" />
        <FormattedMessage
          id={
            isEc
              ? 'pdp:buy-panel:free-shipping-existing-customer:without-style'
              : messageNewCustomer
          }
        />
      </div>
      {isVariantAvailable && (
        <div className="mt-2 flex items-center lg:mt-0">
          <IconCalendar className="mr-1.5 h-5 w-5 shrink-0" />
          {isPreorderProduct ? (
            <FormattedMessage
              id="pdp:buy-panel:pre-order-shipping-date"
              values={{ value: PRE_ORDER_SHIPPING_DATE }}
            />
          ) : (
            <FormattedMessage
              id="pdp:buy-panel:shipping-time"
              values={{ value: shippingTime }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ShippingElement;
